// Definindo eventos com prefixo
export const IdmEventsMap = {
  USER: {
    LOGGED_OUT: 'IDM:USER_LOGGED_OUT',
  },
}

class IDMEvents extends EventTarget {
  emit(eventName: string) {
    const event = new CustomEvent(eventName, {})
    this.dispatchEvent(event)
  }
}

export const IdmEvents = new IDMEvents()
